/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */
import { Typography } from "@material-ui/core";

/* Data Imports */
import AppConfig from "../../../../AppConfig";

/* Define all styles */
const useStyles = makeStyles((theme) => ({
  iconTextRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
      width: "100%",
      gap: "0.5rem",
    },
    gap: "1rem",
    width: "25%",
    border: "1px solid #FFFFFF33",
    borderRadius: "1rem",
    // padding: "1rem",
  },
  text: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: "0.5rem",
  },
  heading: {
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "2rem",
    color: "#212121",
    width: "100%",

    [theme.breakpoints.down("md")]: {
      fontSize: "0.875rem",
      fontWeight: 500,
      lineHeight: "1rem",
      color: "#212121",
    },
  },

  icon: {
    width: 75,
    height: 75,
  },
  imageWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    flexDirection: "row",
  },
}));

const AmenitiesMobileCard = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={`${classes.iconTextRow} ${props.className}`}>
        <div className={classes.text}>
          <Typography
            variant="body2"
            component="span"
            className={classes.heading}
          >
            {props.title ? props.title : "Modern"}
          </Typography>
        </div>
        <div className={classes.imageWrapper}>
          <img
            alt={AppConfig.imageAltText}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.icon}
            src={props.icon ? props.icon : "/images/icons/config/area.svg"}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AmenitiesMobileCard;
